import { Component, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

@Component({
  selector: 'contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ContactFormComponent{
  public isNode:boolean;
  public isDisabled:boolean = true;
  constructor(@Inject(PLATFORM_ID) private platformId:Object){
    this.isNode = isPlatformServer(this.platformId);
  }
  handleCorrectCaptcha($event){
    var elems = JSON.parse(document.getElementsByName("captcha_settings")[0]['value']);
    elems["ts"] = JSON.stringify(new Date().getTime());
    document.getElementsByName("captcha_settings")[0]['value'] = JSON.stringify(elems);
    this.isDisabled = false;
  }
}